













import { Vue, Component } from 'vue-property-decorator';
import CustomContainer from '@/components/Globals/CustomContainer.vue';
import CustomText from '@/components/Globals/CustomText.vue';

@Component({
  components: {
    CustomContainer,
    CustomText
  }
})
export default class ConfirmationShareYourDesign extends Vue {
  get translations() {
    return this.$store.state.translations.data;
  }
}
